/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-shadow */
/* eslint-disable import/no-extraneous-dependencies */
import { Breadcrumb, Button, Card, message } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReloadOutlined } from '@ant-design/icons';
import ActionButton from '../Global/ActionsButton';
import { style } from '../../Styles';
import { deleteKmRangeFare, getAllKmRangeFaresPaged } from '../../redux/KmRangeFareSlice';
import CustomTableComponentsPageable from '../Global/CustomTableComponentsPageable';

import KmRangeFareDrawer from './KmRangeFareDrawer';

const KmRangeFare = ({ role }) => {
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [sortBy, setSortBy] = useState('id');
	const [sortDirection, setSortDirection] = useState('ASC');
	const { Settings } = useSelector((state) => state.settings);
	const currencyRender = () => {
		return <span>{Settings?.settingsData?.currency || '€'}</span>;
	};
	const handleDelete = (id) => {
		setMakingApiCall(true);
		const data = {
			id,
		};
		dispatch(deleteKmRangeFare(data))
			.then(() => {
				message.success('KM Range Fare deleted successfully');
				fetchAllKmRangeFares();
			})
			.catch(() => {
				message.error('Error deleting KM Range Fare');
			})
			.finally(() => {
				setMakingApiCall(false);
			});
	};
	const onEdit = (record) => {
		onRowClick(record);
	};

	const Columns = [
		{
			title: 'ID',
			dataIndex: 'id',
			sorter: true,
			width: 100,
		},
		{
			title: 'From Km',
			key: 'fromKm',
			render: (record) => {
				return <span>{`${record?.fromKm} `}</span>;
			},
			sorter: true,
		},
		{
			title: 'To Km',
			key: 'toKm',
			render: (record) => {
				return <span>{`${record?.toKm} `}</span>;
			},
			sorter: true,
		},
		{
			title: 'Price',
			key: 'price',
			render: (record) => {
				return (
					<span>
						{currencyRender() || '€'} {`${record?.price} `}
					</span>
				);
			},
			sorter: true,
		},
		{
			title: 'Actions',
			key: 'actions',
			render: (text, record) => (
				<ActionButton
					record={record}
					onDelete={() => handleDelete(record?.id)}
					onEdit={() => onEdit(record)}
					recordName={`${record?.id}`}
				/>
			),

			disabled: !role?.includes('SUPER_ADMIN'),
		},
	];

	const [makingApiCall, setMakingApiCall] = useState(false);
	const dispatch = useDispatch();
	const { KmRangeFare } = useSelector((state) => state.kmRangeFare);
	const [kmRangeFare, setKmRangeFare] = useState(null);
	const [showDrwer, setShowDrwer] = useState(false);

	const handleTableChange = (_, __, sorter, extra) => {
		if (extra?.action !== 'sort') return;
		if (sorter.order) {
			setSortBy(sorter.columnKey || sorter.field);
			setSortDirection(sorter.order === 'ascend' ? 'ASC' : 'DESC');
		} else {
			setSortBy('id');
			setSortDirection('ASC');
		}
		setCurrentPage(1);
	};

	const handleOpenDrawer = () => {
		setShowDrwer(true);
	};
	const handleCloseDrawer = () => {
		setKmRangeFare(null);
		setShowDrwer(false);
	};

	const fetchAllKmRangeFares = async () => {
		setMakingApiCall(true);
		dispatch(getAllKmRangeFaresPaged({ page: currentPage - 1, size: pageSize, sortBy, sortDirection }))
			.unwrap()
			.then(() => { })
			.catch(() => {
				message.error('Error fetching KM Range Fares');
			})
			.finally(() => {
				setMakingApiCall(false);
			});
	};

	useEffect(() => {
		fetchAllKmRangeFares();
	}, [currentPage, pageSize, sortBy, sortDirection]);

	const onRowClick = (record) => {
		setKmRangeFare(record);
		handleOpenDrawer();
	};

	const kmRangeFaresArray = KmRangeFare.kmRangeFareList.map((item) => ({ ...item, key: item.id }));
	return (
		<Card
			style={{
				margin: 16,
				maxHeight: '90%', // Set maximum width
				height: 'auto', // Allow width to be dynamic
			}}>
			<div style={style.inlineContent}>
				<div
					style={{
						display: 'flex',
						alignContent: 'center',
						alignItems: 'center',
						float: 'left',
						marginBottom: 8,
					}}>
					<Breadcrumb
						style={{ margin: '0 3em 0 0', fontSize: '1.1em' }}
						items={[
							{
								title: 'Locations',
							},
							{
								title: 'KM Range Fare',
							},
						]}
					/>
					<Button
						type='default'
						size='small'
						// style={{ margin: '0 8px 8px 0' }}
						onClick={() => fetchAllKmRangeFares()}>
						<ReloadOutlined />
					</Button>
				</div>

				<div
				style={{
					...style.inlineContent,
					float: 'right',
					marginBottom: 8,
				}}>
				{role?.includes('SUPER_ADMIN') && (
					<Button
						type='default'
						style={{ float: 'right', marginBottom: 8 }}
						onClick={handleOpenDrawer}>
						Add KM Range Fare
					</Button>
				)}
				</div>
			</div>
			<CustomTableComponentsPageable
				isMakingApiCall={makingApiCall}
				columns={Columns.filter((item) => {
					return !item.disabled;
				})}
				dataArray={kmRangeFaresArray}
				handleDoubleClickRow={(record) => (role?.includes('SUPER_ADMIN') ? onRowClick(record) : {})}
				handleSelectedRow={() => { }}
				onTableChange={handleTableChange}
				pagination={{
					current: currentPage,
					pageSize,
					total: KmRangeFare.total || 0,
					onChange: (page, size) => {
						setCurrentPage(page);
						setPageSize(size);
					},
				}}
			/>
			{showDrwer && (
				<KmRangeFareDrawer
					visible={showDrwer}
					handleClose={handleCloseDrawer}
					kmRangeFareId={kmRangeFare?.id}
				/>
			)}
		</Card>
	);
};

export default KmRangeFare;
